import {
  RoomId,
  roomId,
  RoomStageLayout,
  roomStageLayout
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutUpdateVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutUpdateVO.validationSchema()
  );

  constructor(readonly value: RoomStageLayoutUpdate) {
    JsonSchemaValidator.assert(RoomStageLayoutUpdateVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "layout"],
      properties: {
        roomId,
        layout: roomStageLayout
      }
    };
  }
}

interface RoomStageLayoutUpdate {
  roomId: RoomId;
  layout: RoomStageLayout;
}
